//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
SPLM.AME.Height = Object.freeze({
    "Two" : "Two", "Twopointfive" : "Twopointfive", "Threepointfive" : "Threepointfive", "Five" : "Five", "Seven" : "Seven", "Ten" : "Ten", "Forteen" : "Forteen", "Twenty" : "Twenty", "Seventy" : "Seventy", "Hundred" : "Hundred", "Onehundredforty" : "Onehundredforty", "Twohundred" : "Twohundred", "Twohundredfifty" : "Twohundredfifty"});

SPLM.AME.AmeSymbolAnnotationJustification = Object.freeze({
    "Left" : "Left", "Center" : "Center", "Right" : "Right"});

SPLM.AME.AmeSymbolAnnotationLetteringangle = Object.freeze({
    "Degree0" : "Degree0", "Degree45" : "Degree45", "Degree90" : "Degree90", "Degree135" : "Degree135", "Degree180" : "Degree180", "Degree270" : "Degree270", "Degree315" : "Degree315"});

SPLM.AME.AmeSymbolAnnotationAnchor = Object.freeze({
    "TopLeft" : "TopLeft", "TopCenter" : "TopCenter", "TopRight" : "TopRight", "MiddleLeft" : "MiddleLeft", "MiddleCenter" : "MiddleCenter", "MiddleRight" : "MiddleRight", "BottomLeft" : "BottomLeft", "BottomCenter" : "BottomCenter", "BottomRight" : "BottomRight"});

SPLM.AME.AmeSymbolAnnotationType = Object.freeze({
    "Properties" : "Properties", "ContactBlock" : "ContactBlock"});

SPLM.AME.AmeSymbolAnnotationPropertytype = Object.freeze({
    "ObjectProperties" : "ObjectProperties", "CrossReferences" : "CrossReferences", "AspectProperties" : "AspectProperties"});

SPLM.AME.AmeSymbolAnnotationContactblock = Object.freeze({
    "InPath" : "InPath", "OnComponent" : "OnComponent"});

SPLM.AME.AmeSymbolAnnotationAttributesource = Object.freeze({
    "Unknown" : "Unknown", "Type" : "Type", "Product" : "Product", "General" : "General", "AspectFunction" : "AspectFunction", "AspectLocation" : "AspectLocation", "AspectProduct" : "AspectProduct", "CrossReference" : "CrossReference"});

SPLM.AME.AmeSymbolAnnotationTextOverflowMethod = Object.freeze({
    "Default" : "Default", "Wrap" : "Wrap", "Truncate" : "Truncate", "Overflowborder" : "Overflowborder", "Suffix" : "Suffix"});

export default SPLM;